'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _avatar = require('../../avatar');

var _avatar2 = _interopRequireDefault(_avatar);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  avatar: _propTypes2.default.string,
  compact: _propTypes2.default.bool,
  myMessage: _propTypes2.default.bool,
  fontSize: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  headerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  username: _propTypes2.default.node.isRequired,
  badge: _propTypes2.default.node,
  iconMenu: _propTypes2.default.bool
};

var defaultProps = {
  avatar: '',
  headerStyle: {},
  fontSize: 'small',
  myMessage: false,
  compact: false,
  badge: null,
  iconMenu: false
};

var MessageHeader = function MessageHeader(_ref) {
  var compact = _ref.compact,
      myMessage = _ref.myMessage,
      avatar = _ref.avatar,
      fontSize = _ref.fontSize,
      headerStyle = _ref.headerStyle,
      username = _ref.username,
      badge = _ref.badge,
      iconMenu = _ref.iconMenu;
  return _react2.default.createElement(
    'div',
    { style: _styles2.default.container },
    avatar && !compact ? _react2.default.createElement(_avatar2.default, { image: avatar, style: _getStyles2.default.avatar(myMessage) }) : null,
    _react2.default.createElement(
      'header',
      {
        style: _getStyles2.default.header(myMessage, compact, fontSize, badge, iconMenu, headerStyle)
      },
      username,
      badge ? _react2.default.createElement(
        'div',
        { style: _styles2.default.badge },
        badge
      ) : null
    )
  );
};

MessageHeader.propTypes = propTypes;
MessageHeader.defaultProps = defaultProps;

exports.default = MessageHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message/message-header/index.js
// module id = 62
// module chunks = 0